import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f397e0d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "index-blooding"
}
const _hoisted_2 = { class: "index-blooding__grid" }
const _hoisted_3 = { class: "cell__header" }
const _hoisted_4 = { class: "cell__sextant" }
const _hoisted_5 = { class: "cell__number" }
const _hoisted_6 = { class: "cell__content" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "cell__row" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]


import { ScreeningControllerInterface } from '@/pages/ScreeningPage/screeningController'
import { CellsIDS } from '@/pages/ScreeningPage/screeningModel'

interface Props {
  screeningController: ScreeningControllerInterface
}


export default /*#__PURE__*/_defineComponent({
  props: {
    screeningController: null
  },
  setup(__props: any) {



function getCellStyles(id: CellsIDS) {
  const styles = {
    'cell_left-top': id === 0,
    'cell_right-top': id === 2,
    'cell_left-bottom': id === 3,
    'cell_right-bottom': id === 5,
    'cell_up-down': id > 2,
  }

  return styles
}

return (_ctx: any,_cache: any) => {
  return (__props.screeningController.modifiedBleedingCells)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.screeningController.modifiedBleedingCells, (cell) => {
            return (_openBlock(), _createElementBlock("div", {
              key: cell.id,
              class: _normalizeClass([getCellStyles(cell.id), "index-blooding__cell cell"])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(cell.sextant) + " секстант", 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(cell.number), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", {
                  class: "cell__value",
                  onClick: ($event: any) => (cell.switchStatusValue('up'))
                }, _toDisplayString(cell.values.up ? 1 : 0), 9, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", {
                    class: "cell__value",
                    onClick: ($event: any) => (cell.switchStatusValue('left'))
                  }, _toDisplayString(cell.values.left ? 1 : 0), 9, _hoisted_9),
                  _createElementVNode("p", {
                    class: "cell__value",
                    onClick: ($event: any) => (cell.switchStatusValue('right'))
                  }, _toDisplayString(cell.values.right ? 1 : 0), 9, _hoisted_10)
                ]),
                _createElementVNode("p", {
                  class: "cell__value",
                  onClick: ($event: any) => (cell.switchStatusValue('down'))
                }, _toDisplayString(cell.values.down ? 1 : 0), 9, _hoisted_11)
              ])
            ], 2))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})